import React, {useState} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {
    formatDate,
} from "../prodect/ProsCommonUi";
import {
    OBJ_TYPE_PDF_FRONTPAGE,
    ATTR_UPDATED_MS_I,
    ATTR_UPDATED_BY,
    ATTR_TEXT
} from "../prodect/ProsConnect";
import BasicButton, {ConfirmButton} from "../components/BasicButton";
import LoadingAnimation from "../components/LoadingAnimation";
import PdfReportOptions from "./PdfReportOptions";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";

const MAX_PDF_FRONTPAGE_TEMPLATE_COUNT_PER_CUSTOMER = 15;


export function CustomerPdfFrontpages({ customerId }) {
    
    const [refreshConfigs, setRefreshConfigs] = useState(false)
    const [pdfFrontPageTemplateConfigs, setPdfFrontPageTemplateConfigs] = useState([])
    const [loadingNote, setLoadingNote] = useState('')

    const getCustomerPdfFrontpages = React.useCallback(async () => {
        setLoadingNote("Hetkinen - ladataan PDF-etusivut..")
        const configs = await prosConnect.getCustomerConfigs(customerId, OBJ_TYPE_PDF_FRONTPAGE);
        setPdfFrontPageTemplateConfigs(configs);
        setLoadingNote("");
      }, [customerId]);

    React.useEffect(() => {
        getCustomerPdfFrontpages()
        return () => {
            BasicModalDismiss()
        }
    }, [getCustomerPdfFrontpages, refreshConfigs])


    function renderCustomerPdfFrontpages(){
        if (!pdfFrontPageTemplateConfigs || pdfFrontPageTemplateConfigs.length === 0) {
            return <p>Asiakkaalle ei ole PDF-etusivupohjia.</p>
        }
        return <div className="slab grid-container grid-1 grid-2_lg grid-3_xxl grid-4_hd">
            {pdfFrontPageTemplateConfigs.map(item=> {
            return <div key={item[prosConnect.ATTR_OBJ_ID]}
                    className={"inpage-box"}
                >
                <h3>{item[ATTR_TEXT]}</h3>
                <p>{formatDate(item[ATTR_UPDATED_MS_I], true)}, {item[ATTR_UPDATED_BY]}</p>
                <div className={"btn-set_right"}>
                    <BasicButton
                        btnClass={"2nd"}
                        icon={"edit"}
                        action={() => {
                            openPopUpPdfFrontpageEditor(item)
                        }}
                        btnType={"prompt"}
                    />
                    <ConfirmButton
                        btnClass={"2nd"}
                        label={"Poista"}
                        action={() => {
                            confirmedDelete(item)
                        }}
                        confirmAction
                        hideLabel
                        btnType={"fatal"}
                    />
                </div>
            </div>})}
        </div>
    }

    const confirmedDelete = async (objToBeDeleted) => {
        setLoadingNote("Poistetaan PDF-etusivu...")
        await prosConnect.deleteCustomerConfig(customerId, OBJ_TYPE_PDF_FRONTPAGE, objToBeDeleted)
        setRefreshConfigs(!refreshConfigs)
        setLoadingNote("")
    }

    const openPopUpPdfFrontpageEditor = (pdfObj) => {
        BasicModal("Tallenna PDF-etusivupohja",
            <PdfReportOptions
                closeCallback={BasicModalDismiss}
                setOptionsCallback={(changedData) => savePdfOptionsCallback(pdfObj, changedData)}
                isTemplateEditorMode={true}
                defaultIsCoverPageEnabled={true}
                defaultShowComments={false}
                defaultShowPictures={false}
                defaultPdfCoverPageItems={pdfObj ? pdfObj.content : null}
                defaultPdfCoverPageTemplateName={pdfObj ? pdfObj[ATTR_TEXT] : "Pohjan nimi"}
            />, {
                hideDismissButton: true,
                className: "flexible"
        })
    }

    const savePdfOptionsCallback = async (existingPdfObj, changedData) => {
        // note: existingPdfObj is null if saving new one but is valid object when saving existing object
        await prosConnect.saveCustomerConfig(customerId, OBJ_TYPE_PDF_FRONTPAGE, existingPdfObj, changedData.coverPageTemplateName, {
            content: changedData.coverPage.content
        })
        setRefreshConfigs(!refreshConfigs);
        BasicModalDismiss()
    }

    return <>
        <h2>PDF-etusivupohjat</h2>
        {loadingNote && <LoadingAnimation size={"lg"} text={loadingNote}/>}
        {renderCustomerPdfFrontpages()}
        <BasicButton
            btnClass={"primary"}
            label={"Luo PDF-etusivupohja"}
            icon={"plus"}
            disabled={pdfFrontPageTemplateConfigs.length > MAX_PDF_FRONTPAGE_TEMPLATE_COUNT_PER_CUSTOMER}
            tooltip={
                [pdfFrontPageTemplateConfigs.length > MAX_PDF_FRONTPAGE_TEMPLATE_COUNT_PER_CUSTOMER
                    ? `Voit luoda enintään ${MAX_PDF_FRONTPAGE_TEMPLATE_COUNT_PER_CUSTOMER} PDF-etusivupohjaa per asiakas`
                    : "Luo uusi asiakaskohtainen PDF-etusivupohja "]
            }
            action={()=>{
                openPopUpPdfFrontpageEditor()
            }}
        />
    </>
}
